import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { TREND_EXPORT } from './url-constants';

type TrendSiteExportEndpointSpecification = ApiEndpointSpecification;
export const TrendSiteExportEndpointSpecification: TrendSiteExportEndpointSpecification = {
    url: TREND_EXPORT,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'TrendExportRequestParams',
    requestBodySchemaName: 'TrendExportRequestBody',
    okResponseSchemaName: 'TrendExportOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeTrendSiteExport = Helpers.makeApiRequestFn<
    Types.TrendSiteExportRequestParams,
    Types.TrendSiteExportRequestBody,
    Types.TrendSiteExportOkResponse
>(TrendSiteExportEndpointSpecification);
